// NetSuite records the receivable/internal side as customer invoices (custinvc) and the payable side as
// vendor bills (vendbill). The Onward-prefixed types roll into the same two buckets.
const NETSUITE_TRANSACTION_TYPES = {
    RECEIVABLE: 'custinvc',
    ONWARD_RECEIVABLE: 'custinvc',
    INTERNAL: 'custinvc',
    PAYABLE: 'vendbill',
    ONWARD_PAYABLE: 'vendbill',
};

// Builds the NetSuite transaction record URL for an invoice, or null when we lack the ids/type needed
// to link out. The account id is normalized for the subdomain: lowercased and with underscores swapped
// for hyphens, because NetSuite serves e.g. account 1234567_SB1 from 1234567-sb1.app.netsuite.com.
export const buildNetsuiteInvoiceUrl = (invoice) => {
    const accountId = invoice?.netsuite_account_id;
    const invoiceId = invoice?.netsuite_invoice_id;
    const transactionType = NETSUITE_TRANSACTION_TYPES[invoice?.type];

    if (!accountId || !invoiceId || !transactionType) return null;

    const subdomain = String(accountId).toLowerCase().replace(/_/g, '-');
    return `https://${subdomain}.app.netsuite.com/app/accounting/transactions/${transactionType}.nl?id=${invoiceId}`;
};
